export default __webpack_public_path__ + "static/media/pantry2-before1-768w.23658c90.avif";